import React, { Fragment, useContext } from 'react';
import { IRouteModel } from '../../Routes';
import { NavElements } from '../../enums/RouteEnums';
import GroupItemsLink from './GroupItemsLink';
import NavItem from './NavItem';
import { AppContext } from '../../AppContext';
import { Box, Divider } from '@mui/material';
import { Colors } from '../../utils/theme';
import NavDivider from './NavDivider';

type IPropType = {
  route: IRouteModel;
  selected: string;
  open: boolean;
  userRoles: (string | null)[] | undefined;
  handleSelectedChanged(path: string): void;
};

const ListItemLink: React.FunctionComponent<IPropType> = (props: IPropType) => {
  const { route, selected, open, userRoles, handleSelectedChanged } = props;
  const { state } = useContext(AppContext);
  const hasAccess = route.requiredRole ? userRoles?.includes(route.requiredRole) : true;
  const appRoutes: IRouteModel[] = [];
  state.routes.forEach((r) => {
    r.subRoutes ? r.subRoutes.forEach((sr) => appRoutes.push(sr)) : appRoutes.push(r);
  });
  const routes = appRoutes
    .filter((r: IRouteModel) => r.showInNav)
    .map((re: IRouteModel) => re.path);

  if (!hasAccess) {
    return null;
  }

  const showTopDivider = (route: IRouteModel) => {
    const { path } = route;
    if (
      (open && path && path !== selected && routes.indexOf(path) === 0) ||
      (!open && path && routes.indexOf(path) === 0)
    ) {
      return divider();
    }
    const subRouteIndex = route.subRoutes?.findIndex((r) => r.path === selected);
    if (open && !route.path && subRouteIndex === 0) {
      return divider();
    }
  };

  const showBottomDivider = (route: IRouteModel) => {
    const { path } = route;

    if (!open && path) {
      return divider();
    }
    if (
      (path && path !== selected && routes.indexOf(selected) - 1 !== routes.indexOf(path)) ||
      (path && path !== selected && routes.indexOf(path) === routes.length - 2)
    ) {
      return divider();
    }
  };

  const divider = () => {
    return <NavDivider open={open} />;
  };

  return (
    <Box sx={{ marginRight: '14px', marginLeft: !open ? '14px' : 0 }}>
      {showTopDivider(route)}
      {route.type === NavElements.Group ? (
        <GroupItemsLink
          handleSelectedChanged={handleSelectedChanged}
          open={open}
          route={route}
          selected={selected}
        />
      ) : (
        <NavItem
          key={route.id}
          handleSelectedChanged={handleSelectedChanged}
          selected={selected}
          open={open}
          route={route}
        />
      )}
      {showBottomDivider(route)}
    </Box>
  );
};

export default ListItemLink;
